import { Outlet } from 'react-router-dom';
import { DashboardLayout } from '@repo/ui/components/dashboard-layout';
import { Suspense } from 'react';
import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { MenuAccessGuard } from '@repo/ui/features/superadmin';

export default function AdminLayout() {
  return (
    <DashboardLayout>
      <Suspense fallback={<DendromapLoader message="Chargement du tableau de bord..." />}>
        <MenuAccessGuard>
          <Outlet />
        </MenuAccessGuard>
      </Suspense>
    </DashboardLayout>
  );
}
